import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { LocationSuggestionListItem } from './locationSuggestionListItem';


// TECHDEBT: Should we switch the API to return the favorites in the same format as location API?
// They are serialized in their current format in user cookies so we'd have to convert that data over if we want to make this change.
const mapStoreStateToProps = (storeState) => {
    const { user } = storeState?.appState?.appState || {};
    const locationSearchResults = storeState?.locationSearch?.locationSearchResults || [];
    const recentSearchLocationsUnformatted = storeState?.location?.recentSearchLocations;
    const { ActiveLocation } = user || {};
    const { Locality } = ActiveLocation || {};
    const { CityId } = Locality || {};

    return {
        user,
        recentSearchLocationsUnformatted,
        locationSearchResults,
        CityId
    };
};

const mapDispatchToProps = {};

export const LocationSuggestionList = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    recentSearchLocationsUnformatted,
    locationSearchResults,
    CityId
}) => {
    const recentSearchLocations = recentSearchLocationsUnformatted?.map(x => x?.Location?.Locality);
    const hasResults = locationSearchResults?.length > 0 || recentSearchLocations?.length > 0;
    const suggestionLocations = locationSearchResults?.length > 0 ? locationSearchResults : recentSearchLocations;

    return (
        <Container hasResults={hasResults} id='locationSuggestionList'>
            {suggestionLocations?.map((location, index)=>{
                return <LocationSuggestionListItem
                    key={location.CityId}
                    selected={location?.CityId === CityId}
                    location={location} />;
            })}
        </Container>
    );
});

LocationSuggestionList.propTypes = {
    recentSearchLocations: PropTypes.array,
    locationSearchResults: PropTypes.array,
    CityId: PropTypes.string
};

const Container = styled.ul`
    position: absolute;
    top: 38px;
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    list-style: none;
    font-weight: 400;
    color: #435560;
    font-size: 16px;
    z-index: 100;
    padding: 0;
    ${({ hasResults }) => hasResults && 'border-top: 1px solid rgba(216,216,216,0.5)'};
`;

